import * as React from "react";
const PopperSVG = (props) => (
   <svg
    width="20px"
    height="20px"
    viewBox="0 0 72 72"
    id="emoji"
  >
    <g id="color">
      <polygon
        fill="#FFF"
        stroke="#fff"
        points="26.1808,20.1808 38.75,32.75 51.3192,45.3192 29.7894,54.2798 8.2597,63.2403 17.2202,41.7106"
      />
      <polygon
        fill="#fff"
        stroke="#fff"
        points="40,35 25.6924,20.6692 16.3914,42.5394 7.0905,64.4095"
      />
        <ellipse
        cx={30.2951}
        cy={14.4579}
        rx={2}
        ry={1.9708}
        fill="#fff"
        stroke="none"
      />
      <path fill="#fff" stroke="none" d="M23,37" />
      <ellipse
        cx={60.2951}
        cy={18.4579}
        rx={2}
        ry={1.9708}
        fill="#FFF"
        stroke="none"
      />
      <ellipse
        cx={57.2951}
        cy={39.4579}
        rx={2}
        ry={1.9708}
        fill="#fff"
        stroke="none"
      />
    </g>
    <g id="hair" />
    <g id="skin" />
    <g id="skin-shadow" />
    <g id="line">
      <polyline
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        points="50.6626,45.6395 50.8308,45.8076 28.9606,55.1086 7.0904,64.4096 16.3914,42.5394 25.6923,20.6692"
      />
      <polyline
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        points="25.801,20.7779 38.2616,33.2384 50.6626,45.6395"
      />
      <line
        x1={25.6923}
        x2={25.801}
        y1={20.6692}
        y2={20.7779}
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M46.4905,7.3671c0.2347,0.4487,0.4027,0.943,0.4897,1.473c0.451,2.7473-1.447,5.4141-4.2392,5.9565"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M42.9327,14.7763c-0.5049,0.0384-1.0133,0.1573-1.509,0.364c-2.5697,1.0713-3.828,4.093-2.8105,6.7492"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M61.7928,26.7168c-0.0987,0.4967-0.2778,0.987-0.5425,1.4544c-1.372,2.4225-4.5229,3.309-7.0378,1.98"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M54.3745,30.2558c-0.4173-0.2868-0.8878-0.513-1.4036-0.663c-2.6733-0.7775-5.5486,0.7867-6.4223,3.4936"
      />
    </g>
  </svg>
);
export default PopperSVG;
